import React from 'react'
import PropTypes from 'prop-types'

class Tabs extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    defaultTab: PropTypes.number,
    activeTab: PropTypes.number,
    onTabChange: PropTypes.func,
    style: PropTypes.string,
    className: PropTypes.string,
    preventTabChange: PropTypes.bool,
  }

  state = {
    activeTab: this.props.defaultTab || 0,
  }

  componentDidUpdate(prevProps) {
    if (this.props.defaultTab !== prevProps.defaultTab && this.props.activeTab == null) {
      this.changeTab(this.props.defaultTab || 0)
    }
  }

  static Panel = ({ children, ...props }) => <div {...props}>{children}</div>

  changeTab = (id) => {
    if (!this.props.preventTabChange) {
      if (this.props.activeTab == null) {
        this.setState({ activeTab: id })
      }
    }
    this.props.onTabChange && this.props.onTabChange(id)
  }

  render() {
    const activeTab = this.props.activeTab != null ? this.props.activeTab : this.state.activeTab
    const headings = []

    React.Children.forEach(this.props.children, (child) => {
      if (typeof child === 'object' && child.props.heading) {
        headings.push(child.props.heading)
      }
    })

    return (
      <div>
        <div className={`ctp-tabs ${this.props.className || ''}`} style={{ ...this.props.style }}>
          <header>
            {headings.map((el, index) => (
              <button
                key={`${index}`}
                className={`heading ${index === activeTab ? 'active' : ''}`}
                onClick={() => this.changeTab(index)}
              >
                {el}
              </button>
            ))}
          </header>
        </div>
        <div className="ctp-tabs__content">
          {React.Children.map(this.props.children, (child, index) => {
            if (
              typeof child === 'object' &&
              Object.prototype.hasOwnProperty.call(child.props, 'heading')
            ) {
              headings.push(child.props.heading)
            } else if (process.env.NODE_ENV === 'development') {
              throw new Error('Tabs Component should have only <Tabs.Panel/> as children')
            }

            if (index === activeTab) {
              return child
            }

            return null
          })}
        </div>
      </div>
    )
  }
}

export default Tabs
